import validator from "validator";
import { z } from "zod";

import { getColor } from "../../utils/getColor";

export const ViewEmployeeDetailsModals = ["reactivate", "deactivate", "avatar", "reassign"] as const;

const Config = {
	graphColor: getColor("green", 5) || "#53A93F",
	inputSchema: {
		text: z.string().nullable(),
		monetary: z.union([z.number(), z.string()]).nullable(),
		salary: z
			.union([z.number(), z.string()])
			.nullable()
			.refine((v) => v === null || v === "" || (Number(v) >= 0 && Number(v) <= 10_000_000_000), {
				message: "Salary must be between 0 and 10,000,000,000",
			}),
		numeric: z.union([z.number(), z.string()]).nullable(),
		textbox: z.string().nullable(),
		date: z.date().or(z.string()).nullable().optional(),
		phone: z.string().nullable(),
		person: z
			.object({
				value: z.string(),
				label: z.string(),
			})
			.optional()
			.nullable(),
		people: z
			.array(
				z.object({
					value: z.string(),
					label: z.string(),
				})
			)
			.nullable(),
		email: z.string().refine(validator.isEmail),
		department: z
			.object({
				id: z.string(),
				name: z.string(),
			})
			.nullable(),
		"single-select": z.array(z.string()).nullable(),
		"multi-select": z.array(z.string()).nullable(),
	},

	viewPageSchema: z.object({
		modal: z.enum(ViewEmployeeDetailsModals).optional().catch(undefined),
		search: z.string().optional().catch(""),
		editing: z.boolean().optional().catch(false),
		terminationDate: z.date().optional().catch(undefined),
	}),

	//these fields should always appear in the same order at the top of the page
	STATIC_FIELDS: ["First Name", "Last Name", "Email", "Nickname"],

	imgBasePath: "/static/img/Integrations/",

	INTEGRATIONS_IMAGE_MAP: {
		ukgPro: `ukgpro.png`,
		adpWfn: `ADP.png`,
		adpVantage: `ADP.png`,
		bamboohr: `bamboohr-logo.png`,
		rippling: `rippling-icon.png`,
		gusto: `gusto-icon-orange.png`,
		netchex: `netchex.png`,
		scim: `scim-logo.png`,
	},
};

export default Config;
